import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { State } from "../../../domain/model/ResponseState";
import { Customer } from "../../../domain/model/Customer";
import { GetAllCustomersUseCase } from "../../../domain/usecase/customer/getAll/UseCase";
import { SearchCustomersUseCase } from "../../../domain/usecase/customer/search/UseCase";

export function CustomersViewModel(
  getAllCustomersUseCase: GetAllCustomersUseCase,
  searchCustomersUseCase: SearchCustomersUseCase
) {
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState<string | undefined>();

  const [customers, setCustomers] = useState<Array<Customer> | undefined>([]);

  const [showLoadMoreButton, setShowLoadMoreButton] = useState(false);
  const [showLoadMoreLoading, setShowLoadMoreLoading] = useState(false);
  const [skip, setSkip] = useState(0);
  const limit = 40;

  useEffect(() => {
    if (!searchText || searchText.length == 0) {
      setCustomers([]);
      setSkip(0);
    }
  }, [searchText]);

  useEffect(() => {
    if (skip == 0) {
      getCustomers();
    }
  }, [skip]);

  async function getCustomers() {
    if (skip == 0) setLoading(true);
    else setShowLoadMoreLoading(true);

    const response = await getAllCustomersUseCase.invoke(skip, limit);
    switch (response.responseState) {
      case State.Success:
        if (!response.data) return;
        if (response.data.length < limit) setShowLoadMoreButton(false);
        else setShowLoadMoreButton(true);
        setCustomers(customers?.concat(response.data));
        setSkip(skip + limit);
        break;
      case State.Fail:
      case State.Error:
        showSnackbar(response.error?.message);
        break;
    }
    setLoading(false);
    setShowLoadMoreLoading(false);
  }

  async function searchCompanies() {
    if (!searchText) return;
    setLoading(true);
    const response = await searchCustomersUseCase.invoke(searchText);
    switch (response.responseState) {
      case State.Success:
        setShowLoadMoreButton(false);
        setCustomers(response.data);
        break;
      case State.Fail:
      case State.Error:
        showSnackbar(response.error?.message);
        break;
    }
    setLoading(false);
  }

  function showSnackbar(
    message: string | undefined,
    variant: "error" | "success" = "error"
  ) {
    if (message) enqueueSnackbar(message, { variant: variant });
  }

  return {
    customers,
    searchCompanies,
    searchText,
    setSearchText,
    isLoading,
    setLoading,
    showLoadMoreButton,
    getCustomers,
    showLoadMoreLoading,
  };
}
